import React, { useEffect, useState } from 'react';
import PaymentStep from '../PaymentStep';
import TextDivider from '../../../Parts/TextDivider';
import { Card, Col, Row } from 'react-bootstrap';
import styles from './RMAPaymentOverride.module.scss';
import { RMAItems, RMAPaymentOverrideType, rmaSubmitItem } from './RMAPayment/types';
import TextArea from '../../../Parts/TextArea';
import AddRmaTypeModal from './RMAPayment/RMATypeModal';
import Button from '../../../Parts/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import {  useQuoteIdAndDispatch } from '../../../Store/entities/quotes/hooks';



const RMACard = ({ rmaItem }: { rmaItem: RMAItems }) => {

    const {
        type_code,
        root_cause,
        department,
        sku,
    } = rmaItem;

    return (
        <Card className={`mb-1 ${styles.card} h-100 quote-card`}>
            <Card.Body className={styles.cardBody}>
                <Card.Title>
                    <Row>
                        <Col xs={10} className={styles.cardTitle} /*href={displayId?.href} */>
                            {type_code}
                            {/* <InternalLink content={displayId?.href}>
                                <h5>
                                    {displayId?.accessor()}
                                </h5>
                            </InternalLink> */}
                        </Col>
                        {/* <Col xs={1} sm={2} className="text-end">
                            <QuoteHomeActions quoteId={quote.id} />
                        </Col> */}
                    </Row>
                </Card.Title>
                <Card.Subtitle className="mb-2 text-muted">

                    <div className={styles.companyName}>
                        {sku}
                        {/* <InternalLink content={company?.href}>
                            {company?.accessor()}
                        </InternalLink> */}
                    </div>
                    <div className={styles.createdBy}>
                        {/* <InternalLink content={createdBy?.href}>
                            {createdBy?.accessor()}
                        </InternalLink> */}
                    </div>
                </Card.Subtitle>
                <Card.Text className={styles.cardText}>
                    <Row>
                        <Col>
                            Department: {department}
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            Root Cause: {root_cause}
                        </Col>
                    </Row>
                    {/* {
                        customDisplayColumns.map((column) => (
                            <Row key={column.key} className={column.key} href={column.href ?? ""}>
                                <Col>
                                    {column.title}
                                    : &nbsp;
                                    {column.accessor()}
                                </Col>
                            </Row>
                        ))} */}

                </Card.Text>
            </Card.Body>
        </Card>
    )

};


const RMAPaymentOverride = ({
    setProcessing,
    setSubmit,
    quoteId
}: RMAPaymentOverrideType) => {

    const quoteType = '';

    const quote = useQuoteIdAndDispatch(quoteId);
    const originalQuoteId = quote?.previous_quote_id ?? 0;
    const originalQuote = useQuoteIdAndDispatch(originalQuoteId);


    // const [waiting, setWaiting] = useState(false);
    const [rmaData, setRmaData] = useState<rmaSubmitItem>({
        ticket_number: '',
        expidited_shipping: false,
        root_cause_summary: '',
    });

    const [openAdd, setOpenAdd] = useState(false);

    const addOpen = () => {
        setOpenAdd(true);
    }

    const [rmaItems, setRMAItems] = useState<RMAItems[]>([]);

    useEffect(() => {
        setSubmit(() => {
            // TODO Add
            setProcessing(true);
        });
    }, []);

    const rmaPrimaryItemRows = rmaItems.filter((item) => item.primary).map((item) => {
        return (
            <RMACard
                key={item.type_code}
                rmaItem={item}
            />
        );
    });

    const rmaSecondaryItemRows = rmaItems.filter((item) => !item.primary).map((item) => {
        return (
            <RMACard
                key={item.type_code}
                rmaItem={item}
            />
        );
    });

    // const addRmaType = () => {
    //     // TODO Add
    // };

    // const deleteRmaType = (id: string) => {
    //     // TODO Add
    //     console.log(id);
    // }

    const dateNow = Date.now();
    const dateOriginalPlaced = originalQuote?.ordered_time ?? 0;
    const dateOriginalShipped = originalQuote?.shipments?.reduce((mostRecentTime, quoteShip) => mostRecentTime > quoteShip.time ? mostRecentTime : quoteShip.time, 0) ?? 0;;



    return (
        <PaymentStep>
            <TextDivider>
                <h3 className={`text-${quoteType}`} style={{ fontWeight: 'normal' }}>
                    RMA Configuration
                </h3>
            </TextDivider>
            <Row>
                <Col>
                    <Row>
                        <Col>
                            <Row>
                                <Col>
                                    <label className='underlined' >RMA's</label>
                                </Col>
                                <Col>
                                    <button
                                        onClick={addOpen}
                                    >
                                        Add +
                                    </button>
                                </Col>
                            </Row>
                            <br></br>
                            <Row>
                                {rmaPrimaryItemRows}
                            </Row>
                            <label className='underlined'>Sub RMA's</label>
                            <br></br>
                            <Row>
                                {rmaSecondaryItemRows}
                            </Row>
                        </Col>

                    </Row>
                </Col>
                <Col>
                    <TextArea
                        key={`root-cause-summary`}
                        label="Root Cause Summary"
                        wrapperStyle={{ alignSelf: "center" }}
                        style={{
                            resize: "vertical",
                            width: "80%",
                            height: "10em",
                        }}
                        disabled={
                            false
                        }
                        defaultValue={""}
                        onChange={(new_value) => {
                            setRmaData({
                                ...rmaData,
                                root_cause_summary: new_value,
                            })
                        }}
                        maxLength={20000}
                    />
                </Col>

            </Row>
            <Row className=''>
                <Col className="m-2">
                    <Row>
                        <label className='underlined'>Ticket Number</label>
                    </Row>
                    <Row>
                        <input
                            type='text'
                            value={rmaData.ticket_number}
                            onChange={(e) => {
                                setRmaData({
                                    ...rmaData,
                                    ticket_number: e.target.value,
                                })
                            }}
                        />
                    </Row>
                </Col>
                <Col  className="m-2">
                    <Row>
                        <label className='underlined'>Expedited Shipping</label>
                    </Row>
                    <Row>
                        <Button
                            radioButton
                            color={(rmaData?.expidited_shipping ?? false) ? 'red' : 'grey'}
                            fluid
                            fullWidth
                            onClick={() => setRmaData({
                                ...rmaData,
                                expidited_shipping: !rmaData.expidited_shipping
                            })}
                        >
                            Expidited Shipping &nbsp;
                            {
                                rmaData.expidited_shipping
                                    ? (<FontAwesomeIcon icon={faCheck} />)
                                    : (<FontAwesomeIcon icon={faTimes} />)
                            }
                        </Button>
                    </Row>
                </Col>
            </Row>
            <Row className='mt-4'>
                <Col>
                    <label className='underlined'>Date Original Ordered</label>
                    <text>{`${new Date(dateOriginalPlaced * 1000)}`}</text>
                </Col>
                <Col>
                    <label className='underlined'>Date Original Shipped</label>
                    <text>{`${new Date(dateOriginalShipped * 1000)}`}</text>
                </Col>
                <Col>
                    <label className='underlined'>Date RMA Generated</label>
                    <text>{`${new Date(dateNow)}`}</text>
                </Col>
                <Col>
                    <label className='underlined'>Date RMA Shipped</label>
                    <text>Unknown</text>
                </Col>
            </Row>
           
            <AddRmaTypeModal
                openAddRMATypeModal={openAdd}
                addRmaType={(rmaType) => {
                    // TODO Add
                    setRMAItems([...rmaItems, rmaType]);

                }}
                setOpenAddRMATypeModal={setOpenAdd}
            />
        </PaymentStep>
    )

};


export default RMAPaymentOverride;